module.exports = __webpack_public_path__ + "img/ic_up_20.4c6408a2.svg";